import type { HubSpotProduct } from "../types/configurator";

export const MOCK_PRODUCTS: HubSpotProduct[] = [
  { id: "hs-001", name: "Indoor 2-Person Sauna", price: 4200, category: "Sauna Type", sku: "SAU-IN-2P" },
  { id: "hs-002", name: "Indoor 4-Person Sauna", price: 6800, category: "Sauna Type", sku: "SAU-IN-4P" },
  { id: "hs-003", name: "Outdoor 4-Person Sauna", price: 8500, category: "Sauna Type", sku: "SAU-OUT-4P" },
  { id: "hs-004", name: "Outdoor 6-Person Sauna", price: 11200, category: "Sauna Type", sku: "SAU-OUT-6P" },
  { id: "hs-005", name: "Canadian Cedar", price: 800, category: "Wood Finish", sku: "WOOD-CED" },
  { id: "hs-006", name: "Nordic Hemlock", price: 650, category: "Wood Finish", sku: "WOOD-HEM" },
  { id: "hs-007", name: "Thermo Aspen", price: 950, category: "Wood Finish", sku: "WOOD-ASP" },
  { id: "hs-008", name: "Nordic Pine", price: 500, category: "Wood Finish", sku: "WOOD-PIN" },
  { id: "hs-009", name: "Harvia 6kW Heater", price: 1200, category: "Heaters", sku: "HTR-6KW" },
  { id: "hs-010", name: "Harvia 9kW Heater", price: 1600, category: "Heaters", sku: "HTR-9KW" },
  { id: "hs-011", name: "Infrared Panel Set", price: 2100, category: "Heaters", sku: "HTR-IR" },
  { id: "hs-012", name: "LED Chromotherapy Kit", price: 350, category: "Accessories", sku: "ACC-LED" },
  { id: "hs-013", name: "Wooden Bucket & Ladle", price: 85, category: "Accessories", sku: "ACC-BKT" },
  { id: "hs-014", name: "Sauna Stones 20kg", price: 65, category: "Accessories", sku: "ACC-STN" },
  { id: "hs-015", name: "Digital Control Panel", price: 420, category: "Accessories", sku: "ACC-DCP" },
  { id: "hs-016", name: "Bluetooth Speaker System", price: 280, category: "Accessories", sku: "ACC-SPK" },
  { id: "hs-017", name: "Tempered Glass Door", price: 550, category: "Doors & Windows", sku: "DW-GLS" },
  { id: "hs-018", name: "Cedar Frame Door", price: 380, category: "Doors & Windows", sku: "DW-CED" },
  { id: "hs-019", name: "Window Panel 40x60", price: 220, category: "Doors & Windows", sku: "DW-WIN" },
];

/**
 * Build a product lookup map for O(1) access
 */
export function buildProductMap(products: HubSpotProduct[]): Record<string, HubSpotProduct> {
  const map: Record<string, HubSpotProduct> = {};
  for (const p of products) {
    map[p.id] = p;
  }
  return map;
}

/**
 * Group products by category
 */
export function groupByCategory(products: HubSpotProduct[]): Record<string, HubSpotProduct[]> {
  const groups: Record<string, HubSpotProduct[]> = {};
  for (const p of products) {
    if (!groups[p.category]) groups[p.category] = [];
    groups[p.category].push(p);
  }
  return groups;
}
